<template>
  <div class="standard-input-item" :style="'max-width:'+width">
    <div>
      <div style="color:#fff" class="standard-input-title">{{label}}</div>

      <input
        @input="inputChange"
        :autocomplete="name"
        data-vv-value-path="dValue"
        :data-vv-as="label"
        v-validate="isRequired"
        v-model="inputValue"
        ref="input"
        :class="{'input': true, 'is-danger': errors.has(name),'filled' : hasValue  }"
        :id="id"
        :type="type"
        :name="name"
        class="standardInput"
      />
      <span v-show="errors.has(name)" class="help is-danger">{{ errors.first(name) }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    isRequired: "",
    inputValue: "",
    confirm: false
  }),
  inject: ["$validator"],
  props: [
    "type",
    "width",
    "name",
    "label",
    "required",
    "placeholder",
    "value",
    "id",
    "passwordConfirm",
    "password",
    "onChange"
  ],
  mounted() {
    this.inputValue = this.value || "";
    if (this.required) {
      this.isRequired = "required";
    }
    if (this.passwordConfirm) {
      this.isRequired = "required|confirmed:" + this.password;
    }
  },
  watch: {
    password(val) {
      this.isRequired = "required|confirmed:" + val;
    },
    value(val) {
      if (val != null) {
        this.inputValue = val;
      }
    }
  },
  computed: {
    hasValue() {
      if (this.inputValue == "") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    inputChange() {
      if (this.onChange) {
        this.onChange(this.$refs.input.value);
      }
    }
  }
};
</script>
<style>
.standardInput {
  width: 100%;
  background: transparent;
  color: #fff;
  padding: 10px;
  border: solid 1px #fff;
  transition: all 0.3s ease;
}
.standardInput:focus {
  border: solid 1px #01c2fe;
  background: #01c2fe40 !important;
}
.filled {
  background: #01feb299;
  border: solid 1px #01feb2;
}
.standard-input-title {
  font-size: 15pt;
}

::placeholder {
  color: #ffffff90;
}
</style>